import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import { ZERO_WIDTH_SPACE_CSS } from "../../../../lib/chars";
import { css, memoizeStyle } from "../../../../lib/theming/Emotion";
import { styles } from "../../Input.styles";
export var stylesLayout = memoizeStyle({
  root: function root(t) {
    return styles.root(t);
  },
  input: function input() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      min-width: 0;\n      overflow: hidden;\n      position: relative;\n      width: 100%;\n      display: flex;\n    "])));
  },
  aside: function aside() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      display: inline-flex;\n      align-items: center;\n      flex-shrink: 0;\n\n      &::before {\n        content: '", "';\n      }\n    "])), ZERO_WIDTH_SPACE_CSS);
  },
  icon: function icon(t) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "])), t.inputIconColor);
  },
  iconFocus: function iconFocus(t) {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "])), t.inputFocusedIconColor);
  },
  iconDisabled: function iconDisabled(t) {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      cursor: default;\n      color: ", ";\n    "])), t.inputIconColorDisabled);
  },
  text: function text(t) {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "])), t.inputPlaceholderColor);
  },
  textDisabled: function textDisabled(t) {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n      color: ", ";\n    "])), t.inputPlaceholderColorDisabled);
  }
});